import { useEffect, useRef } from 'react';

/**
 * Guarda de sessao/duplo-clique compartilhada por dialogs de mutacao real que
 * ficam sempre montados (so `open` alterna, nunca desmontam) dentro de uma
 * tela que sobrevive a troca de processo — extraido de `DialogTitulo.jsx`/
 * `DialogExcluirTitulo.jsx` (AW2-1034), onde o mesmo bloco existia duplicado
 * byte-a-byte. Ver `src/prototipo/CLAUDE.md`, secao "Dialog de mutacao real
 * dentro de AbaAcompanhamento.jsx".
 *
 * `sessaoRef` invalida qualquer callback de uma sessao anterior (reabertura
 * do dialog OU troca de `idProcesso`, mesmo com o dialog fechado) — evita que
 * uma resposta tardia de mutacao aplique efeito (onSucesso/erro) sobre o
 * processo/sessao errado na UI (condicao de corrida assincrona; a
 * autorizacao real permanece no backend). `enviandoRef` e a guarda sincrona
 * contra duplo-clique (um `useState` so reflete no proximo render).
 *
 * `aoAbrir` roda so na transicao real fechado->aberto, nunca por outro
 * motivo — guardada via "latest ref" (nunca como dependencia do efeito) para
 * uma nova referencia de funcao a cada render do consumidor nao disparar o
 * reset indevidamente.
 */
export default function useSessaoDialogMutacao(open, idProcesso, aoAbrir) {
  const aoAbrirRef = useRef(aoAbrir);
  aoAbrirRef.current = aoAbrir;

  const foiAbertoRef = useRef(false);
  const sessaoRef = useRef(0);
  const enviandoRef = useRef(false);
  const idProcessoAnteriorRef = useRef(idProcesso);

  useEffect(() => {
    if (open && !foiAbertoRef.current) {
      sessaoRef.current += 1;
      enviandoRef.current = false;
      if (aoAbrirRef.current) {
        aoAbrirRef.current();
      }
    }
    foiAbertoRef.current = open;
  }, [open]);

  useEffect(() => {
    if (idProcessoAnteriorRef.current !== idProcesso) {
      sessaoRef.current += 1;
      enviandoRef.current = false;
      idProcessoAnteriorRef.current = idProcesso;
    }
  }, [idProcesso]);

  return { sessaoRef, enviandoRef };
}
